import React from 'react';

import CustomErrorCard from '@components/error-cards/CustomErrorCard';
import useText from '@hooks/use-text';

export const CouldNotFetchAccountsErrorCard = () => {
    const { messageErrorUps, orderBankCardFailureText } = useText();

    return <CustomErrorCard title={messageErrorUps} description={orderBankCardFailureText} />;
};
